(() => {
  function initializeSubscriptionModule(blockId) {
    const ulElement = document.getElementById(blockId);
    if (!ulElement) return;
    const liItems = ulElement.getElementsByTagName('li');
    for (let i = 0; i < liItems.length; i++) {
      liItems[i].addEventListener('click', function () {
        for (let j = 0; j < liItems.length; j++) {
          liItems[j].classList.remove('active-product');
        }
        this.classList.add('active-product');
      });
    }
  }

  function stripQueryParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    urlParams.delete(param);
    const qs = urlParams.toString();
    window.history.replaceState({}, '', `${window.location.pathname}${qs ? '?' + qs : ''}`);
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('ElevatorSubModule')) initializeSubscriptionModule('ElevatorSubModule');
    if (document.getElementById('GiftSubs')) initializeSubscriptionModule('GiftSubs');

    const triggerButton = document.getElementById('ingredientsPopupTrigger');
    const popup = document.getElementById('ingredientsPopup');
    const body = document.getElementById('Body');
    const urlParams = new URLSearchParams(window.location.search);

    if (triggerButton && body) {
      triggerButton.addEventListener('click', () => body.classList.add('ingredients-popup-open'));
      if (urlParams.get('trigger') === 'ingredients_list') {
        body.classList.add('ingredients-popup-open');
      }
      popup?.addEventListener('click', () => body.classList.remove('ingredients-popup-open'));
    }

    if (urlParams.get('open-reviews')) {
      setTimeout(() => {
        const ratingElement = document.querySelector('.ruk-rating-snippet-count');
        if (ratingElement) {
          ratingElement.click();
          stripQueryParam('open-reviews');
        }
      }, 100);
    }

    if (urlParams.get('write-review')) {
      setTimeout(() => {
        const writeReviewElement = document.getElementById('writeReview');
        if (writeReviewElement) {
          writeReviewElement.click();
          stripQueryParam('write-review');
        }
      }, 100);
    }
  });
})();
